import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import CalmLogo from 'icons/calm-app-logo.svg';

export const Wrapper = styled.section`
	overflow: hidden;
	padding: 94px 0 0;
	position: relative;
	text-align: center;

	${minWidth('tablet')} {
		padding: 160px 0 168px;
		text-align: left;
	}
`;

export const Logo = styled(CalmLogo)`
	height: auto;
	margin-bottom: 20px;
	width: 174px;

	${minWidth('tablet')} {
		margin-bottom: 60px;
		width: 102px;
	}
`;

export const Heading = styled.h2`
	color: ${palette('white')};
	${fontWeight(FontWeights.Regular)}
	font-size: 34px;
	line-height: 1.16;
	margin-bottom: 20px;

	${minWidth('tablet')} {
		font-size: 60px;
		margin-bottom: 60px;
	}
`;

export const JayHeadshot = styled.img`
	width: 100%;
	position: relative;

	${minWidth('tablet')} {
		bottom: 0;
		height: auto;
		position: absolute;
		max-width: 1000px;
		right: 0;
		width: 66%;
		z-index: -1;
	}
`;

export const StyledButton = styled(Button)`
	max-width: 335px;
`;

export const ButtonWrapper = styled.div`
	margin: 0 auto 36px;
	width: calc(100% - 32px);

	${minWidth('tablet')} {
		margin: 0;
		width: auto;
	}
`;
